import React,{useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Faq from "react-faq-component";

const data = {
    title: "FAQs",
    rows: [
        {
            title: "What is the ACCA qualification, and why should I pursue it?",
            content: `The ACCA (Association of Chartered Certified Accountants) qualification is globally recognised and provides extensive knowledge in accounting, finance, and business management. It enhances career prospects and is ideal for those pursuing senior positions in accounting.`,
        },
        {
            title: "How can I enroll in an ACCA course on your eCampus?",
            content:
                "You can easily enrol by visiting our ACCA course page on eCampus, selecting your desired course level, and completing the registration process. If you need assistance, our support team is available to guide you through the process.",
        },
        {
            title: "Do I need prior experience or qualifications to start an ACCA course?",
            content: `While prior experience is helpful, ACCA offers entry routes for both those with accounting backgrounds and those new to the field. We also offer preparatory courses to help you get started.`,
        },
        {
            title: "How long does it take to complete the ACCA qualification?",
            content: `The time to complete the ACCA qualification depends on your prior qualifications and the number of exams you pass. On average, it can take 3 to 4 years to become a fully qualified ACCA member.`,
        },
        {
            title: "What are the career opportunities after completing the ACCA qualification?",
            content: `ACCA graduates can pursue roles in accounting, auditing, financial management, corporate finance, and consultancy across various industries, both in the UK and globally.`,
        },
        {
            title: "What is ACDAP, and how can it help me in my career in digital accounting?",
            content: `ACDAP (Association of Certified Digital Accounting Professionals) offers certifications in digital accounting, enabling you to develop expertise in accounting software and modern financial practices, leading to enhanced career prospects.`,
        },
        {
            title: "What courses are available through ACDAP?",
            content: `ACDAP offers certifications at various stages: Foundation (Digital Bookkeeper & Payroll), Advanced (Digital Assistant Accountant), and Professional (Digital Accounting Professional) to cater to individuals at different career stages.`,
        },
        {
            title: "Is the ACDAP qualification recognised by employers?",
            content: `Yes, ACDAP certifications are highly regarded by employers, especially those looking for professionals skilled in digital accounting software and modern accounting practices.`,
        },
        {
            title: "How can I register for an ACDAP course on your platform?",
            content: `To register for an ACDAP course, visit the eCampus website, select the course you are interested in, and follow the enrollment instructions. You'll gain access to course materials and learning support once enrolled.`,
        },
        {
            title: "Can ACDAP help me find employment after completing my course?",
            content: `Yes, ACDAP offers career support, including CV writing assistance and interview preparation, as well as access to our extensive recruitment network to help you secure a job after completing your course.`,
        },
        {
            title: "What is the AAT qualification, and who is it for?",
            content: `The AAT (Association of Accounting Technicians) qualification is ideal for those starting a career in accounting or looking to enhance their accounting skills. It covers the fundamentals of accounting and bookkeeping, making it perfect for beginners.`,
        },
        {
            title: "Can I complete the AAT qualification online through your eCampus?",
            content: `Yes, we offer flexible online learning options for AAT qualifications. You can study at your own pace with access to course materials, live support, and assessments to help you succeed.`,
        },
        {
            title: "What are the different levels of AAT courses available?",
            content: `AAT offers three main levels: Foundation (Level 2), Advanced (Level 3), and Professional (Level 4). You can start at the level that suits your experience and career goals.`,
        },
        {
            title: "How long does it take to complete an AAT qualification?",
            content: `Depending on the level you pursue, AAT qualifications typically take between 12 to 24 months. Our flexible learning solutions help you to progress at a pace that fits your schedule.`,
        },
        {
            title: "How can AAT help me in my career?",
            content: `The AAT qualification is highly respected by employers and provides essential accounting and bookkeeping skills. It opens up career opportunities in various roles, including accounts assistant, bookkeeper, and management accountant.`,
        },
        {
            title: "What is CPD, and why is it important?",
            content: `CPD (Continuing Professional Development) is called ongoing learning and training that professionals undertake to keep their skills and knowledge up-to-date. It is essential for maintaining professional competence and career advancement.`,
        },
        {
            title: "Are the CPD courses accredited by professional bodies?",
            content: `Yes, many of our CPD courses are accredited by recognised professional bodies like AAT, ACCA, ACDAP, and CIMA. These accreditations ensure that your CPD points are valid and recognised in your industry.`,
        },
        {
            title: "How can I earn CPD points through your eCampus?",
            content: `You can earn CPD points by enrolling in and completing our range of CPD-approved courses. These courses cover various topics in accounting, finance, and management, and you'll receive CPD certification upon completion.`,
        },
        {
            title: "What types of CPD courses are offered on the eCampus?",
            content: `Our eCampus offers CPD courses in accounting, bookkeeping, digital accounting, tax, payroll, financial management, and more. Courses are designed to enhance your skills and knowledge in specialised areas of finance.`,
        },
        {
            title: "How can I track my CPD progress on the eCampus?",
            content: `Our platform provides a built-in progress tracker that allows you to monitor the number of CPD points earned, courses completed, and your overall development, ensuring you stay on track with your professional growth.`,
        },
    ],
};

const styles = {
    // bgColor: 'white',
    titleTextColor: "#383838",
    rowTitleColor: "#383838",
    // rowContentColor: 'grey',
    // arrowColor: "red",
};

const config = {
    // animate: true,
    // arrowIcon: "V",
    // tabFocus: true
    // openOnload: 1,
};



const FaqPage = () => {

    const [rows, setRowsOption] = useState(null);

useEffect(() => {
        if (rows) {
            for (let i = 0; i < rows.length; i++) {
                rows[i].expand();
            }    
        }
    }, [rows]);

	return (
		<>
			
			{/*<!-- Page Banner Section Start -->*/}
    <div className="section page-banner-section" style={{backgroundImage: 'url(../assets/images/banner.jpg)'}}>
    <div className="overlayBanner"></div>
        <div className="container">
            {/*<!-- Page Banner Content End -->*/}
            <div className="page-banner-content">
                <h2 className="title">Faqs</h2>

                <ul className="breadcrumb">
                    <li><Link to="/">Home</Link></li>
                    <li className="active">Faqs</li>
                </ul>
            </div>
            {/*<!-- Page Banner Content End -->*/}
        </div>
    </div>
    {/*<!-- Page Banner Section End -->*/}

    {/*<!-- Contact Section Start -->*/}
    <div className="section section-padding">
        <div className="container">
            {/*<!-- Contact Wrapper Start -->*/}
            		
            	<Faq
	                data={data} getRowOptions={setRowsOption}
	                styles={styles}
	                config={config}
	            />
                <p className="mt-5 text-center"><b>If you have any further questions, please do not hesitate to contact us.</b></p>
            {/*<!-- Contact Wrapper End -->*/}
        </div>
    </div>
    {/*<!-- Contact Section End -->*/}
			
		</>
	)
}

export default FaqPage